import {Component, EventEmitter, Input, Output} from '@angular/core'
import {LogoDisplayComponent} from './logo-display/logo-display.component'
import {UserWidgetComponent} from './user-widget/user-widget.component'
import {User} from 'src/app/shared/models/user'
import {Chantier} from "../../../shared/models/chantier";
import {FormsModule} from "@angular/forms";
import {ChantierSelectorComponent} from "./chantier-selector/chantier-selector.component";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [LogoDisplayComponent, UserWidgetComponent, ChantierSelectorComponent, FormsModule, NgIf],
})
export class HeaderComponent {

  @Input({required: true})
  logoHeuresInsertionUrl: string
  @Input({required: true})
  connectedUser: User
  @Input({required: true})
  selectableUserChantiers: Chantier[]
  @Input()
  selectedChantier: Chantier
  @Output()
  chantierSelected = new EventEmitter<string>

  @Output()
  private readonly logout = new EventEmitter<void>()

  logOut(): void {
    this.logout.emit()
  }

  onChantierSelected(selectedChantierCode: string): void {
    this.chantierSelected.emit(selectedChantierCode)
  }
}
